







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Button, Card } from 'element-ui';
import Avatar from '@/components/Avatar.vue';
import UserEdit from '@/components/modals/UserEdit.vue';

import { OperatorFields } from '@/types/graphql/schemaTypes';

@Component({
  components: {
    Avatar,
    UserEdit,
    'el-button': Button,
    'el-card': Card
  }
})

export default class UserDetail extends Vue {
  @Prop() public user!: OperatorFields;

  openEditModal = false;

  get avatar() {
    return this.user.avatar?.url;
  }
}
